/* unplugin-vue-components disabled */import script from "./indexExample.vue?vue&type=script&setup=true&lang=js"
export * from "./indexExample.vue?vue&type=script&setup=true&lang=js"

import "./indexExample.vue?vue&type=style&index=0&id=82ded066&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82ded066"]])

export default __exports__